// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__HlnQX","btnOffer":"AddProduct_btnOffer__u5GI5"};